export default "__VITE_ASSET__ff3911ef__"